const policy_schedule = ({
	issueDate,
	policyNumber,
	agentNumber,
	policyHolders,
	insuredName,
	startDate,
	endDate,
	renewalDate,
	underwritingYear,
	standardPremium,
	loading,
	discountRatio,
	discountAmount,
	levyAmount,
	levyRatio,
	totalPremium
}) => {
	return `
  <!DOCTYPE html>

<html lang="en" xmlns="http://www.w3.org/1999/xhtml">

<head>
  <meta charset="utf-8" />
  <title>VHIS_Standard_Plan_-_Policy_Schedule</title>
  <style>
    .tal {
      text-align: left;
    }

    .bt {
      border-top: 1px solid black;
    }

    .bb {
      border-bottom: 1px solid black;
    }

    .ff-msjh {
      font-family: "Droid Sans";
    }

    .bbdot {
      border-bottom: 1px dotted black;
    }

    .width50pc {
      width: 50%;
    }

    .widthFixed {
      width: 100%;
    }

    .fs10 {
      font-size: 10pt;
    }

    .fw400 {
      font-weight: 400
    }

    .fw700 {
      font-weight: 700
    }

    p {
      font-size: 12pt;
      font-family: Arial;
      text-align: left;
    }

    table {
      border-collapse: collapse;
    }

    td {
      padding: 0.6pt 0.6pt 0.6pt 0.6pt;
      line-height: 1.15;
    }

    .header__container {
      float: left;
      display: block;
      width: 100%;
      margin: 0 0 25px 0;
    }

    .header__image {
      width: 100%;
    }
  </style>
</head>

<body>
  <div style="margin: 0 auto;">
    <div style="margin: 0 auto;">
      <div class="widthFixed" style="margin: 0 auto;">
        <table style="width: 100%;">
          <tr>
            <td width="90%">
            </td>
            <td class="text-align:right;">
              <span>
                <img style="width: 149.72px; height: 38.00px; float: right;"
                  src="data:image/png;base64,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"
                  alt="" />
              </span>
            </td>
          </tr>
        </table>
      </div>
      <div align="center">
        <table class="widthFixed">
          <tr>
            <td class="bt">
              <p class="fw700 fs10">
                <span>VHIS Certification Plan no.:</span><span>
                  &nbsp;<br>
                </span><span
                  class="ff-msjh">&#33258;&#39000;&#37291;&#20445;&#35469;&#21487;&#29986;&#21697;&#32232;&#34399;:</span>
              </p>
            </td>
            <td class="bt">
              <p class="fs10 fw400"><span>S00027-01-000-02</span></p>
            </td>
            <td class="bt">
              <p class="fw700 fs10">
                Issue Date:<br>
                <span class="ff-msjh">&#30332;&#20986;&#26085;&#26399;: </span>
              </p>
            </td>
            <td class="bt">
              <p class="fs10 fw400"><span>${issueDate}</span></p>
            </td>
          </tr>
          <tr>
            <td>
              <p class="fw700 fs10">
                Product Type:<br>
                <span class="ff-msjh">&#29986;&#21697;&#39006;&#21029;:</span>
              </p>
            </td>
            <td>
              <p class="fs10 fw400">
                VHIS (Standard) Plan<br>
                <span class="ff-msjh">&#33258;&#39000;&#37291;&#20445;(&#27161;&#28310;&#35336;&#21123;)
                </span>
              </p>
            </td>
            <td>
              <p class="fw700 fs10">
                Page:<br>
                <span class="ff-msjh">&#38913;&#25976;:
                </span>
              </p>
            </td>
            <td>
              <p class="fs10 fw400"><span>1/1</span></p>
            </td>
          </tr>
          <tr>
            <td>
              <p class="fw700 fs10">
                Product Name:<br>
                <span class="ff-msjh">&#29986;&#21697;&#21517;&#31281;:
                </span>
              </p>

            </td>
            <td>
              <p class="fs10 fw400">
                Asia Unique &ndash; Family Care<br>
                <span class="ff-msjh">&#24310;&#24859;
                </span>
              </p>
            </td>
            <td>
              <p class="fw700 fs10">
                Currency:<br>
                <span class="ff-msjh">&#36008;&#24163;:
                </span>
              </p>
            </td>
            <td>
              <p class="fs10 fw400">
                HKD<br>
                <span class="ff-msjh">&#28207;&#20803;
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p class="fw700 fs10">
                Policy Number:<br>
                <span class="ff-msjh">&#20445;&#21934;&#32232;&#34399;:
                </span>
              </p>
            </td>
            <td>
              <p class="fs10 fw400"><span>${policyNumber}</span></p>
            </td>
            <td>
              <p class="fw700 fs10">
                Agent/Broker Number:<br>
                <span class="ff-msjh">&#20445;&#38570;&#39015;&#21839;/&#20195;&#29702;&#34399;&#30908;:
                </span>
              </p>
            </td>
            <td>
              <p class="fs10 fw400"><span>${agentNumber}</span></p>
            </td>
          </tr>
          <tr>
            <td>
              <p class="fw700 fs10">
                Name of Policy Holder(s):<br>
                <span class="ff-msjh">&#20445;&#21934;&#25345;&#26377;&#20154;&#22995;&#21517;:
                </span>
              </p>
            </td>
            <td>
              <p class="fs10 fw400"><span>${policyHolders
								.map(holder => holder)
								.join("<br>")}</span></p>
            </td>
            <td>
              <p class="fw700 fs10">
                Premium Payment:<br>
                <span class="ff-msjh">&#32371;&#20184;&#20445;&#36027;&#26041;&#24335;:
                </span>
              </p>
            </td>
            <td>
              <p class="fs10 fw400">
                Annual<br>
                <span class="ff-msjh">&#24180;&#32371;
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p class="fw700 fs10">
                Name of Insured Person:<br>
                <span class="ff-msjh">&#21463;&#20445;&#20154;&#22995;&#21517;:
                </span>
              </p>
            </td>
            <td>
              <p class="fs10 fw400"><span>${insuredName}</span></p>
            </td>
            <td>
              <p class="fw700 fs10">
                Policy Effective Date:<br>
                <span class="ff-msjh"> &#20445;&#21934;&#29983;&#25928;&#26085;:
                </span>
              </p>
            </td>
            <td>
              <p class="fs10 fw400"><span>${startDate}</span></p>
            </td>
          </tr>
          <tr>
            <td>
              <p class="fw700 fs10">
                Underwriting Year:<br>
                <span class="ff-msjh"> &#26680;&#20445;&#24180;&#24230;:
                </span>
              </p>
            </td>
            <td>
              <p class="fs10 fw400"><span>${underwritingYear}</span></p>
            </td>
            <td>
              <p class="fw700 fs10">
                First Renewal Date:<br>
                <span class="ff-msjh">&#39318;&#20491;&#32396;&#20445;&#26085;:</span>
              </p>
            </td>
            <td>
              <p class="fs10 fw400"><span>${renewalDate}</span></p>
            </td>
          </tr>
        </table>
        <p class="fw700 fs10 widthFixed bt bb">
          Period Cover: From ${startDate} To ${endDate} (both dates inclusive)<br>
          <span class="ff-msjh">&#20445;&#38556;&#26399;&#38480;: &#30001; ${startDate} &#33267;
            ${endDate} (&#21253;&#25324;&#39318;&#23614;&#20841;&#26085;)
          </span>
        </p>
        <table class="widthFixed">
          <tr>
            <td class="width50pc bbdot">
              <p class="fw700 fs10">
                Insurance Coverage<br>
                <span class="ff-msjh">&#20445;&#38556;&#31684;&#22285;</span>
              </p>
            </td>
            <td class="bbdot">
              <p class="fs10 fw400">
                As per benefit schedule attached.<br>
                <span
                  class="ff-msjh">&#35531;&#21443;&#38321;&#38468;&#19978;&#20043;&#20445;&#38556;&#34920;&#12290;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td class="bbdot">
              <p class="fw700 fs10">
                Standard Premium<br>
                <span class="ff-msjh"> &#27161;&#28310;&#20445;&#36027;</span>
              </p>
            </td>
            <td class="bbdot">
              <p class="fs10 fw400"><span>${standardPremium}</span></p>
            </td>
          </tr>
          <tr>
            <td class="bbdot">
              <p class="fw700 fs10">
                Smoker Loading (if any)<br>
                <span
                  class="ff-msjh">&#21560;&#29017;&#20154;&#22763;&#38468;&#21152;&#20445;&#36027;&#65288;&#22914;&#36969;&#29992;&#65289;</span>
              </p>
            </td>
            <td class="bbdot">
              <p class="fs10 fw400"><span>$0.00</span></p>
            </td>
          </tr>
          <tr>
            <td class="bbdot">
              <p class="fw700 fs10">
                Premium Loading (if any)(loading due to medical condition/ occupation/country of
                residency)<br>
                <span
                  class="ff-msjh">&#20854;&#20182;&#38468;&#21152;&#20445;&#36027;&#65288;&#22914;&#36969;&#29992;&#65289;<br>
                  (&#22240;&#36523;&#39636;&#29376;&#27841;/&#32887;&#26989;/&#23621;&#20303;&#22283;&#23478;&#32780;&#38468;&#21152;&#30340;&#20445;&#36027;)</span>
              </p>
            </td>
            <td class="bbdot">
              <p class="fs10 fw400"><span>$${
								loading !== 0
									? loading
											.toFixed(2)
											.toString()
											.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
									: "0.00"
							} *</span></p>
            </td>
          </tr>
          <tr>
            <td class="bbdot">
              <p class="fw700 fs10">
                Discount ${discountRatio ? discountRatio : "(if any)"}<br>
                <span class="ff-msjh"> &#25240;&#25187; ${
									discountRatio ? discountRatio : "(&#22914;&#36969;&#29992;)"
								}<span>
              </p>
            </td>
            <td class="bbdot">
              <p class="fs10 fw400"><span>${discountAmount}</span></p>
            </td>
          </tr>
          <tr>
            <td class="bbdot">
              <p class="fw700 fs10">
                Levy (${levyRatio}%)<br>
                <span class="ff-msjh"> &#20445;&#36027;&#24501;&#36027;(${levyRatio}%)</span>
              </p>
            </td>
            <td class="bbdot">
              <p class="fs10 fw400"><span>$${levyAmount}</span></p>
            </td>
          </tr>
          <tr>
            <td class="bbdot">
              <p class="fw700 fs10">
                Total Premium<br>
                <span class="ff-msjh">&#32317;&#20445;&#36027;</span>
              </p>
            </td>
            <td class="bbdot">
              <p class="fs10 fw400"><span>${totalPremium}</span></p>
            </td>
          </tr>
        </table>
        <p><span></span></p>
        <p class="widthFixed fs10" style="font-style: italic">
          *Detail please refer to debit note &amp; endorsement.<br>
          <span
            class="ff-msjh">*&#35443;&#24773;&#35531;&#21443;&#38321;&#32371;&#36027;&#36890;&#30693;&#26360;&#21450;&#35036;&#20805;&#25991;&#20214;</span><span
            class="c26">&#12290;</span>
        </p>
        <p><span></span></p>
        <p class="widthFixed fs10" style="font-style: italic">
          Note: The Renewal premium will be indicated in the Renewal notice.<br>
          <span class="ff-msjh">&#20633;&#35387;:
            &#32396;&#20445;&#20445;&#36027;&#23559;&#36617;&#26044;&#32396;&#20445;&#36890;&#30693;&#26360;&#20839;</span><span
            class="c26">&#12290;</span>
        </p>
      </div>
    </div>
</body>

</html>
    `
}

export { policy_schedule }
